import { openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7055b22c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    ref: "chartEle",
    class: "chart",
    style: `width: ${_ctx.width}px; height: ${_ctx.height}px;`
  }, null, 4))
})